import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import { useLocation } from 'react-router-dom'

import { List, ListItem, ListItemText, Grid } from '@material-ui/core';
import HasAccess from '../components/auth/HasAccess';
import AuthService, { Roles } from '../services/auth';

// state
import state from '../store/index';

interface AuthenticatedContainerProps {
  children: any;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  selected: {
    borderBottom: '1px solid #00c1e4'
  }
}))

const ProfileContainer: React.FC<AuthenticatedContainerProps> = (props) => {

  const classes = useStyles();

  const getCampaignLink = () => {
    const userRoles = AuthService.getRoles();
    if (userRoles.indexOf(Roles.textadmin) !== -1) {
      return '/admin/campaigns/run';
    }
    return '/campaigns';
  }

  return (
    <div className="profile-page">
      <Grid container spacing={5}>
        <Grid item md={2}>
          <div className="tabs">
            <a href="/profile" className={window.location.pathname === '/profile' ? classes.selected : undefined }>
              Profile
            </a>
            <a href="/profile/notifications" className={window.location.pathname === '/profile/notifications' ? classes.selected : undefined }>
              Notifications
            </a>
            <a href={getCampaignLink()} className={window.location.pathname === getCampaignLink() ? classes.selected : undefined }>
              Campaigns
            </a>
            <HasAccess roles={[Roles.user]}>
              <a href="/organizations" className={location.pathname === '/organizations' ? classes.selected : undefined }>
                Organizations
              </a>
            </HasAccess>
            <HasAccess roles={[Roles.superadmin]}>
              <a href="/admin" className={window.location.pathname === '/admin' ? classes.selected : undefined }>
                Admin
              </a>
            </HasAccess>
          </div>
        </Grid>
        <Grid item md={10}>
          <div style={{marginBottom: 100}}>
            {props.children}
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

export default ProfileContainer;



// WEBPACK FOOTER //
// ./src/containers/Profile.tsx